import dayjs from "dayjs";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import toast from "react-hot-toast";

import type { CouponDateTimeType } from "@/types/qr";
import { copyToClipboard, isClient } from "@/utils/browser";
import { logError } from "@/services/DatadogService";
import type { CouponAddressVisibility, CouponDateStatus } from "./types";

dayjs.extend(isSameOrBefore);
dayjs.extend(utc);
dayjs.extend(timezone);

export const getCouponDateStatus = (
  couponDateTime?: CouponDateTimeType
): CouponDateStatus | null => {
  if (!couponDateTime?.couponValidDate) {
    return null;
  }

  const defaultTimezone = dayjs.tz.guess();
  const couponDate = dayjs.tz(
    couponDateTime.couponValidDate,
    couponDateTime.couponTimezone || defaultTimezone
  );
  const currentLocalDate = dayjs().tz(dayjs.tz.guess());
  const isValidDate = currentLocalDate.isSameOrBefore(couponDate, "day");

  return {
    isValidDate,
    formattedDate: couponDate.format("YYYY/MM/DD"),
  };
};

export const getCouponAddressVisibility = (
  locationAddress: string | undefined,
  isFlipped: boolean,
  isInitialPreview: boolean | undefined
): CouponAddressVisibility => {
  if (!locationAddress) {
    return { showFrontAddress: false, showBottomAddress: false };
  }

  return {
    showFrontAddress: !isFlipped && isInitialPreview === undefined,
    showBottomAddress: isFlipped || isInitialPreview === true,
  };
};

export const handleCopyCouponCode = (couponName: string, copiedMessage: string): void => {
  if (!isClient()) {
    return;
  }

  try {
    copyToClipboard(couponName);
    toast.success(copiedMessage, {
      id: "myToast",
      duration: 1500,
      position: "top-center",
      icon: "📋",
    });
  } catch (error) {
    logError(error instanceof Error ? error : new Error(String(error)), {
      component: "CouponTemplate",
      action: "handleCopyCouponCode",
    });
  }
};
